import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 4px;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.line};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Texts = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Hint = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const Price = styled.span<{ $active: boolean }>`
  font-weight: 800;
  font-size: 13.5px;
  white-space: nowrap;
  color: ${(p) => (p.$active ? p.theme.tokens.colors.teal : p.theme.tokens.colors.muted)};
`;
